import React from "react";
import {MainCP}  from "../../../Components/reforma-pensiones/reforma-pensiones-v2/MainCP"

const ViewReformaPensionesv2: React.FC = () => <MainCP/>

export default ViewReformaPensionesv2;